import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import clsx from 'clsx';
import { Close } from '@mui/icons-material';

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
  },
  link: {
    cursor: 'pointer',
    '&hover': {
      textDecoration: 'underline',
    },
  },
}));

interface AttachmentProps {
  className?: string;
  filename: string;
  size: number;
  mode?: 'upload';
  onDelete?: () => unknown;
  onDownload?: () => unknown;
}

export const Attachment = (props: AttachmentProps) => {
  const styles = useStyles();

  return (
    <li className={clsx(styles.container, props.className)}>
      <span className={props.onDownload ? styles.link : undefined} onClick={props.onDownload}>
        {props.filename}
      </span>
      {props.onDelete && (
        <IconButton onClick={props.onDelete} size='large'>
          <Close />
        </IconButton>
      )}
    </li>
  );
};
